import React, { ReactElement, ReactNode } from 'react';
import { LogFn } from 'pino';

import { DataIdProvider, GlobalStyle, Toaster } from '@dexma/ui-components';
import { CommonStyle } from 'adapter/in/common/style';
import ErrorBoundary from 'adapter/in/common/components/ErrorBoundary';

import getProfileApiClient from 'adapter/out/client/profile/getProfileApiClient';
import getProfileUseCase from 'use-case/profile/get/getProfileUseCase';
import { ProfileStaticProvider } from 'adapter/in/common/context/static/Profile';

import readBrandingApiClient from 'adapter/out/client/branding/readBrandingApiClient';
import readBrandingUseCase from 'use-case/branding/read/readBrandingUseCase';
import { BrandingStaticProvider } from 'adapter/in/common/context/static/Branding';
import { AlertToasterProvider } from 'adapter/in/common/context/Alert';

type AppProvidersProps = {
    dataId: string;
    fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>;
    baseUrl: string;
    errorLog: LogFn;
    children: ReactNode;
};

const AppProviders = ({ dataId, fetch, baseUrl, errorLog, children }: AppProvidersProps): ReactElement => (
    <DataIdProvider dataId={dataId}>
        <ProfileStaticProvider getProfile={getProfileUseCase(getProfileApiClient(fetch, baseUrl))}>
            <BrandingStaticProvider readBranding={readBrandingUseCase(readBrandingApiClient(fetch, baseUrl))}>
                <GlobalStyle />
                <CommonStyle />
                <ErrorBoundary onError={errorLog}>
                    <Toaster>
                        <AlertToasterProvider>{children}</AlertToasterProvider>
                    </Toaster>
                </ErrorBoundary>
            </BrandingStaticProvider>
        </ProfileStaticProvider>
    </DataIdProvider>
);

export default AppProviders;
